import './pictures.css';
import type { CSSProperties } from 'react';
import type { FoodPicture } from '../../data/food-pictures';
import { pictureUrl } from './pictures';

// DE: Das Bild füllt gut die Hälfte des Tellers, wie in den Entwürfen.
// EN: The picture fills a good half of the plate, as in the mockups.
const PICTURE_SHARE = 0.62;

interface FoodPlateProps {
  picture: FoodPicture;
  /** DE: Durchmesser in px. EN: Diameter in px. */
  size: number;
  /** DE: Nur wenn daneben kein Text dasselbe nennt. EN: Only when no text beside names the same. */
  label?: string;
  /** DE: Großer Teller eines Gerichts in eigener Farbe. EN: Large dish plate in its own colour. */
  dish?: boolean;
}

/**
 * DE: Runder „Teller“ mit einem Essensbild; ohne `label` reine Verzierung.
 * EN: Round "plate" with a food picture; without `label` pure decoration.
 */
export function FoodPlate({ picture, size, label, dish = false }: FoodPlateProps) {
  const side = Math.round(size * PICTURE_SHARE);
  const style = { '--plate-size': `${size}px` } as CSSProperties;
  return (
    <span className={dish ? 'app-plate app-plate-dish' : 'app-plate'} style={style}>
      <img
        src={pictureUrl(picture)}
        alt={label ?? ''}
        aria-hidden={label === undefined ? true : undefined}
        width={side}
        height={side}
        loading="lazy"
      />
    </span>
  );
}

/**
 * DE: Kleines Essensbild ohne Teller, z. B. vor einem Ladennamen; immer reine Verzierung.
 * EN: Small food picture without a plate, e.g. before a store name; always pure decoration.
 */
export function FoodIcon({ picture, size }: { picture: FoodPicture; size: number }) {
  return (
    <img
      className="app-food-icon"
      src={pictureUrl(picture)}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      loading="lazy"
    />
  );
}
